import React from 'react';
import { cn } from '../../lib/utils';
interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'card' | 'image' | 'circle';
}
export function Skeleton({
  className,
  variant = 'text',
  ...props
}: SkeletonProps) {
  const variants = {
    text: 'h-4 w-full rounded',
    card: 'h-32 w-full rounded-xl',
    image: 'h-48 w-full rounded-xl',
    circle: 'h-12 w-12 rounded-full'
  };
  return <div className={cn('animate-pulse bg-gray-200', variants[variant], className)} {...props} data-id="element-1764" />;
}